/*
 * Signature Modal
 */

import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import SignaturePad from './SignaturePad';
import { IinitialState } from '../../reducers';
import { IinstallBasePopulated, IfacilityContact } from '../../models';
import { WithCommonModal } from '../common/WithCommonModal';
import { selectIsLoading } from '../../reducers/commonReducers';
import {
    submitJobSignature,
    toggleIsCollectingSignatures,
    toggleIsJobClosingWithSignature,
    hideApproverSigning
} from '../../actions/workOrderActions';
import { toggleModalSignaturePad } from '../../actions/manageInventoryActions';
import { completeJobWithFinalCheck, updateJob } from '../../actions/manageJobActions';
import { jobSourceEnum } from '../../models-enums';
import { getDefaultCoverLetter } from '../../constants/constants';

interface Iprops {
    colorButton: string;
    installBasesPopulated: IinstallBasePopulated[];
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops & WithTranslation) => {
    const job = state.manageJob.selectedJob;
    const validateParts = job.source === jobSourceEnum.BPCS;
    const selectedJobSignatures = Object.values(state.manageJob.jobSignaturesByID).filter(
        signature => signature.jobID === job.id
    );
    const { isCollectingSignatures, isJobClosingWithSignature, isApproverSigning } = state.workOrder as any;
    const facility = state.facilities.facilitiesByID[job.facilityID];
    const facilityStandardName = facility ? state.productInfo.standards[facility.standardID]?.name : undefined;
    const facilityContacts: IfacilityContact[] = state.contactsByFacility[job.facilityID] || [];

    return {
        className: 'signature-modal',
        show: state.manageInventory.showSignatureModal,
        user: state.user,
        title: isApproverSigning
            ? ownProps.t('approverSignatureTitle')
            : isJobClosingWithSignature
            ? ownProps.t('signaturePadModalTitle')
            : ownProps.t('collectJobSignatures'),
        selectedJob: job,
        selectedJobSignatures,
        selectedJobCoverLetter: job.coverLetter,
        defaultCoverLetter: getDefaultCoverLetter(facilityStandardName),
        isJobClosingWithSignature,
        isCollectingSignatures,
        isApproverSigning: isApproverSigning ?? false,
        validateParts,
        installBasesPopulated: ownProps.installBasesPopulated,
        facilityContacts,
        loading: selectIsLoading(state)
    };
};

export default withTranslation('manageInventory')(
    connect(mapStateToProps, {
        updateJob,
        completeJobWithFinalCheck,
        submitSignature: submitJobSignature,
        toggleModalSignaturePad,
        toggleIsCollectingSignatures,
        toggleModal: toggleModalSignaturePad,
        toggleIsJobClosingWithSignature,
        hideApproverSigning,
        onHide: toggleModalSignaturePad
    })(WithCommonModal(SignaturePad))
);
